<template>
  <l-marker :lat-lng="coords">
    <l-icon :icon-size="icon.iconSize" class-name="circle-marker">
      <div class="circle-marker-label" :style="{ borderColor: color }">
        {{ label }}
      </div>
    </l-icon>
  </l-marker>
</template>

<script>
import { LIcon, LMarker } from "vue2-leaflet";
import { HEAT_COLOR } from "@/config/visibility_level";

export default {
  name: "MapCircleMarker",
  components: {
    LMarker,
    LIcon
  },
  props: {
    coords: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: HEAT_COLOR.DEFAULT
    },
    label: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      icon: {
        iconSize: [34, 34],
        iconAnchor: [17, 17],
        className: "circle-marker"
      }
    };
  }
};
</script>

<style lang="scss">
.circle-marker {
  border-radius: 50%;
  filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.25));
}

.circle-marker-label {
  background: $light;
  border-width: 5px;
  border-style: solid;
  border-radius: 50%;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $grey-darker;
  font-family: $font-family-base;
  font-weight: 500;
  @include font-size(12px);
}
</style>
